import { IconProps } from '../../../common/types'

const HeightIcon: React.FC<IconProps> = () => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="128"
      height="128"
      viewBox="0 0 512 512"
    >
      <path
        d="M0 0 C168.96 0 337.92 0 512 0 C512 168.96 512 337.92 512 512 C343.04 512 174.08 512 0 512 C0 343.04 0 174.08 0 0 Z "
        fill="#F6F7F6"
        transform="translate(0,0)"
      />
      <path
        d="M0 0 C59.73 0 119.46 0 181 0 C181 39.93 181 79.86 181 121 C240.4 121 299.8 121 361 121 C361 130.9 361 140.8 361 151 C301.6 151 242.2 151 181 151 C181 270.13 181 389.26 181 512 C121.27 512 61.54 512 0 512 C0 343.04 0 174.08 0 0 Z "
        fill="#8CF2F1"
        transform="translate(0,0)"
      />
      <path
        d="M0 0 C24.75 0 49.5 0 75 0 C75 39.93 75 79.86 75 121 C134.4 121 193.8 121 255 121 C255 130.9 255 140.8 255 151 C195.6 151 136.2 151 75 151 C75 270.13 75 389.26 75 512 C50.25 512 25.5 512 0 512 C0 472.07 0 432.14 0 391 C-4.95 391 -9.9 391 -15 391 C-15 381.1 -15 371.2 -15 361 C-10.05 361 -5.1 361 0 361 C0 331.3 0 301.6 0 271 C-4.95 271 -9.9 271 -15 271 C-15 261.1 -15 251.2 -15 241 C-10.05 241 -5.1 241 0 241 C0 211.3 0 181.6 0 151 C-4.95 151 -9.9 151 -15 151 C-15 141.1 -15 131.2 -15 121 C-10.05 121 -5.1 121 0 121 C0 81.07 0 41.14 0 0 Z "
        fill="#56D9D4"
        transform="translate(106,0)"
      />
      <path
        d="M0 0 C9.9858569 8.47055236 16.49816561 18.62395648 17.734375 31.75 C18.37447971 44.12334485 15.50094776 55.53056156 7.26171875 65.1015625 C0.56358885 72.09273559 -6.34959188 76.97069729 -15.61328125 80.05859375 C5.17671875 80.38859375 25.96671875 80.71859375 47.38671875 81.05859375 C47.38671875 130.55859375 47.38671875 180.05859375 47.38671875 231.05859375 C37.48671875 231.05859375 27.58671875 231.05859375 17.38671875 231.05859375 C17.38671875 261.08859375 17.38671875 291.11859375 17.38671875 322.05859375 C-12.31328125 322.05859375 -42.01328125 322.05859375 -72.61328125 322.05859375 C-72.61328125 292.02859375 -72.61328125 261.99859375 -72.61328125 231.05859375 C-82.51328125 231.05859375 -92.41328125 231.05859375 -102.61328125 231.05859375 C-102.61328125 181.55859375 -102.61328125 132.05859375 -102.61328125 81.05859375 C-81.82328125 80.72859375 -61.03328125 80.39859375 -39.61328125 80.05859375 C-42.91328125 78.73859375 -46.21328125 77.41859375 -49.61328125 76.05859375 C-61.48918473 68.84024431 -68.70831022 58.28339749 -72.078125 44.98828125 C-74.2864995 32.89863984 -72.11953892 21.43042749 -65.61328125 11.05859375 C-57.88201348 0.66727208 -48.69274394 -6.04785167 -35.88671875 -8.51171875 C-22.42875808 -10.27827683 -11.01241808 -8.18112375 0 0 Z "
        fill="#FE9000"
        transform="translate(313.61328125,189.94140625)"
      />
      <path
        d="M0 0 C24.75 0 49.5 0 75 0 C75 79.53 75 159.06 75 241 C50.25 241 25.5 241 0 241 C0 201.07 0 161.14 0 120 C-4.95 120 -9.9 120 -15 120 C-15 110.1 -15 100.2 -15 90 C-10.05 90 -5.1 90 0 90 C0 60.3 0 30.6 0 0 Z "
        fill="#56D9D4"
        transform="translate(106,271)"
      />
      <path
        d="M0 0 C0 108.9 0 217.8 0 330 C-14.85 330 -29.7 330 -45 330 C-45 299.97 -45 269.94 -45 239 C-54.9 239 -64.8 239 -75 239 C-75 189.5 -75 140 -75 89 C-54.21 88.67 -33.42 88.34 -12 88 C-15.3 86.68 -18.6 85.36 -22 84 C-33.87590348 76.78165056 -41.09502897 66.22480374 -44.46484375 52.9296875 C-46.67321825 40.84004609 -44.50625767 29.37183374 -38 19 C-27.78024478 5.26399098 -17.00400937 0 0 0 Z "
        fill="#FDBE01"
        transform="translate(286,182)"
      />
      <path
        d="M0 0 C10.23 0 20.46 0 31 0 C31 168.96 31 337.92 31 512 C20.77 512 10.54 512 0 512 C0 343.04 0 174.08 0 0 Z "
        fill="#F6F7F7"
        transform="translate(0,0)"
      />
      <path
        d="M0 0 C29.7 0 59.4 0 90 0 C90 9.9 90 19.8 90 30 C80.1 30 70.2 30 60 30 C60 119.43 60 208.86 60 301 C69.9 301 79.8 301 90 301 C90 310.9 90 320.8 90 331 C60.3 331 30.6 331 0 331 C0 321.1 0 311.2 0 301 C9.9 301 19.8 301 30 301 C30 211.57 30 122.14 30 30 C20.1 30 10.2 30 0 30 C0 20.1 0 10.2 0 0 Z "
        fill="#474D53"
        transform="translate(391,181)"
      />
      <path
        d="M0 0 C24.75 0 49.5 0 75 0 C75 39.93 75 79.86 75 121 C50.25 121 25.5 121 0 121 C0 81.07 0 41.14 0 0 Z "
        fill="#57D9D3"
        transform="translate(106,391)"
      />
      <path
        d="M0 0 C24.75 0 49.5 0 75 0 C75 39.93 75 79.86 75 121 C50.25 121 25.5 121 0 121 C0 81.07 0 41.14 0 0 Z "
        fill="#57D9D3"
        transform="translate(106,0)"
      />
      <path
        d="M0 0 C89.1 0 178.2 0 270 0 C270 9.9 270 19.8 270 30 C180.9 30 91.8 30 0 30 C0 20.1 0 10.2 0 0 Z "
        fill="#27BDBD"
        transform="translate(91,121)"
      />
      <path
        d="M0 0 C29.7 0 59.4 0 90 0 C90 9.9 90 19.8 90 30 C60.3 30 30.6 30 0 30 C0 20.1 0 10.2 0 0 Z "
        fill="#26BEBE"
        transform="translate(91,361)"
      />
      <path
        d="M0 0 C29.7 0 59.4 0 90 0 C90 9.9 90 19.8 90 30 C60.3 30 30.6 30 0 30 C0 20.1 0 10.2 0 0 Z "
        fill="#26BEBE"
        transform="translate(91,241)"
      />
      <path
        d="M0 0 C19.8 0 39.6 0 60 0 C60 9.9 60 19.8 60 30 C40.2 30 20.4 30 0 30 C0 20.1 0 10.2 0 0 Z "
        fill="#26BEBE"
        transform="translate(121,421)"
      />
      <path
        d="M0 0 C19.8 0 39.6 0 60 0 C60 9.9 60 19.8 60 30 C40.2 30 20.4 30 0 30 C0 20.1 0 10.2 0 0 Z "
        fill="#26BEBE"
        transform="translate(121,301)"
      />
      <path
        d="M0 0 C19.8 0 39.6 0 60 0 C60 9.9 60 19.8 60 30 C40.2 30 20.4 30 0 30 C0 20.1 0 10.2 0 0 Z "
        fill="#26BEBE"
        transform="translate(121,181)"
      />
      <path
        d="M0 0 C19.8 0 39.6 0 60 0 C60 9.9 60 19.8 60 30 C40.2 30 20.4 30 0 30 C0 20.1 0 10.2 0 0 Z "
        fill="#26BEBE"
        transform="translate(121,61)"
      />
      <path
        d="M0 0 C0 0.66 0 1.32 0 2 C0.69713104 1.99777939 1.39426208 1.99555878 2.11251831 1.99327087 C8.67529238 1.97325202 15.23805796 1.95801771 21.80085564 1.94818783 C25.17503026 1.94296435 28.54917971 1.93587639 31.92333984 1.92456055 C35.80046259 1.91247564 39.6775494 1.90676737 43.5546875 1.90234375 C44.76929657 1.89718246 45.98390564 1.89202118 47.23532104 1.88670349 C48.91683762 1.88659019 48.91683762 1.88659019 50.63232422 1.88647461 C51.62271698 1.884254 52.61310974 1.88203339 53.6335144 1.87974548 C56 2 56 2 58 3 C57.89290363 22.80110522 57.78016826 42.60217061 57.66066074 62.40320492 C57.60530778 71.59650825 57.55182245 80.78981546 57.50268555 89.9831543 C57.45986903 97.99309473 57.41359755 106.00300635 57.36312145 114.01290232 C57.33650003 118.25675562 57.31164653 122.50060312 57.29092598 126.74448967 C57.27139137 130.73431871 57.24725733 134.72409279 57.21950912 138.71387291 C57.2101218 140.18248246 57.20245261 141.65110409 57.19658089 143.1197319 C57.18834826 145.1162578 57.17348264 147.11275315 57.15821838 149.10923767 C57.15176583 150.22921615 57.14531328 151.34919462 57.1386652 152.50311184 C57 155 57 155 56 156 C46.43 156 36.86 156 27 156 C27 185.37 27 214.74 27 245 C26.34 245 25.68 245 25 245 C25 214.97 25 184.94 25 154 C34.9 154 44.8 154 55 154 C55 104.5 55 55 55 4 C32.89 4 10.78 4 -12 4 C-4 0 -4 0 0 0 Z "
        fill="#FEF2CE"
        transform="translate(306,267)"
      />
      <path
        d="M0 0 C24.09 0.33 48.18 0.66 73 1 C73 50.5 73 100 73 151 C63.1 151 53.2 151 43 151 C43 181.03 43 211.06 43 242 C42.67 242 42.34 242 42 242 C42 211.31 42 180.62 42 149 C51.57 149 61.14 149 71 149 C71 100.82 71 52.64 71 3 C49.22 3 27.44 3 5 3 C2.525 2.01 2.525 2.01 0 1 C0 0.67 0 0.34 0 0 Z "
        fill="#E59529"
        transform="translate(288,270)"
      />
      <path
        d="M0 0 C2.82012894 1.11095989 5.56906722 2.26842793 8.3125 3.5625 C12.37563426 5.14643369 15.67970959 5.62102716 20 6 C20 6.66 20 7.32 20 8 C20.99 8.33 21.98 8.66 23 9 C22.34 9.66 21.68 10.32 21 11 C-1.44 11 -23.88 11 -47 11 C-47 59.51 -47 108.02 -47 158 C-37.76 158 -28.52 158 -19 158 C-19 158.33 -19 158.66 -19 159 C-28.9 159 -38.8 159 -49 159 C-49 109.5 -49 60 -49 9 C-28.21 8.67 -7.42 8.34 14 8 C10.7 6.68 7.4 5.36 4 4 C1.375 1.75 1.375 1.75 0 0 Z "
        fill="#ECBE31"
        transform="translate(260,262)"
      />
      <path
        d="M0 0 C1.21236328 0.52400391 1.21236328 0.52400391 2.44921875 1.05859375 C4.05216797 1.74115234 4.05216797 1.74115234 5.6875 2.4375 C6.74324219 2.88996094 7.79898438 3.34242188 8.88671875 3.80859375 C11.61972529 4.85447455 14.12042337 5.53520748 17 6 C17 6.33 17 6.66 17 7 C-5.44 7 -27.88 7 -51 7 C-51 56.5 -51 106 -51 157 C-51.66 156.67 -52.32 156.34 -53 156 C-53 106.5 -53 57 -53 6 C-50.53838983 4.76919491 -48.93503007 4.87956023 -46.18310547 4.88647461 C-45.18221893 4.88655014 -44.1813324 4.88662567 -43.15011597 4.88670349 C-42.06674957 4.89186478 -40.98338318 4.89702606 -39.8671875 4.90234375 C-38.76021515 4.9037587 -37.6532428 4.90517365 -36.51272583 4.90663147 C-32.96679007 4.91224228 -29.42091677 4.92479663 -25.875 4.9375 C-23.47526133 4.94251361 -21.07552167 4.94707675 -18.67578125 4.95117188 C-12.78383275 4.96221522 -6.89192084 4.9789639 -1 5 C-0.67 3.35 -0.34 1.7 0 0 Z "
        fill="#FEF7C8"
        transform="translate(262,264)"
      />
      <path
        d="M0 0 C4.95 0 9.9 0 15 0 C15 9.9 15 19.8 15 30 C10.05 30 5.1 30 0 30 C0 20.1 0 10.2 0 0 Z "
        fill="#58D8D4"
        transform="translate(91,361)"
      />
      <path
        d="M0 0 C4.95 0 9.9 0 15 0 C15 9.9 15 19.8 15 30 C10.05 30 5.1 30 0 30 C0 20.1 0 10.2 0 0 Z "
        fill="#58D8D3"
        transform="translate(91,241)"
      />
      <path
        d="M0 0 C4.95 0 9.9 0 15 0 C15 9.9 15 19.8 15 30 C10.05 30 5.1 30 0 30 C0 20.1 0 10.2 0 0 Z "
        fill="#58D8D4"
        transform="translate(91,121)"
      />
      <path
        d="M0 0 C0.66 0 1.32 0 2 0 C3.03746171 2.3219381 4.02709526 4.65100477 5 7 C5.28617187 7.6290625 5.57234375 8.258125 5.8671875 8.90625 C7.89711459 13.93273612 8.28592395 18.7411863 8.3125 24.125 C8.31789795 24.79394287 8.3232959 25.46288574 8.32885742 26.15209961 C8.26299327 30.79867236 7.42518764 34.62791044 6 39 C5.34 39 4.68 39 4 39 C3.896875 39.721875 3.79375 40.44375 3.6875 41.1875 C2.94013068 44.24491993 1.71954811 46.38329635 0 49 C-0.66 48.67 -1.32 48.34 -2 48 C-1.66226562 47.35933594 -1.32453125 46.71867187 -0.9765625 46.05859375 C-0.53054688 45.19363281 -0.08453125 44.32867187 0.375 43.4375 C0.81585938 42.59058594 1.25671875 41.74367187 1.7109375 40.87109375 C6.3489629 30.54094628 6.63702359 18.87207596 3.0625 8.1875 C2.39418135 6.45082968 1.71023033 4.71995537 1 3 C0.67 2.01 0.34 1.02 0 0 Z "
        fill="#FEEFC8"
        transform="translate(325,203)"
      />
      <path
        d="M0 0 C4.84993514 4.18289535 6.58505558 10.86610411 7.20849609 17.07714844 C7.32425114 19.24279343 7.37229011 21.39385037 7.375 23.5625 C7.37653076 24.25303467 7.37806152 24.94356934 7.37963867 25.6550293 C7.29908957 29.29323881 7.06793384 30.89809925 5 34 C4.97494385 33.36497559 4.9498877 32.72995117 4.92407227 32.07568359 C4.80743211 29.17528458 4.68501607 26.27515651 4.5625 23.375 C4.52318359 22.37597656 4.48386719 21.37695312 4.44335938 20.34765625 C4.23427386 15.49043896 3.97041445 10.77867956 3 6 C2.01 6 1.02 6 0 6 C0 4.02 0 2.04 0 0 Z "
        fill="#EA9D30"
        transform="translate(324,203)"
      />
      <path
        d="M0 0 C2.82012894 1.11095989 5.56906722 2.26842793 8.3125 3.5625 C12.37563426 5.14643369 15.67970959 5.62102716 20 6 C20 6.66 20 7.32 20 8 C20.99 8.33 21.98 8.66 23 9 C21 11 21 11 17.0859375 11.1953125 C15.51550649 11.18200376 13.94513779 11.15813602 12.375 11.125 C11.57320313 11.11597656 10.77140625 11.10695313 9.9453125 11.09765625 C7.96341477 11.07406223 5.98167019 11.03819065 4 11 C4 10.67 4 10.34 4 10 C8.62 9.67 13.24 9.34 18 9 C16.14375 8.4225 14.2875 7.845 12.375 7.25 C7.65203544 5.68126118 3.87137121 4.11860459 0 1 C0 0.67 0 0.34 0 0 Z "
        fill="#F4C329"
        transform="translate(260,262)"
      />
      <path
        d="M0 0 C0.67998047 0.00064453 1.35996094 0.00128906 2.06054688 0.00195312 C7.04669423 0.04669423 7.04669423 0.04669423 8.1875 1.1875 C10.51567964 1.55510731 12.8493385 1.88991581 15.1875 2.1875 C15.1875 2.8475 15.1875 3.5075 15.1875 4.1875 C14.115 4.0225 13.0425 3.8575 11.9375 3.6875 C2.44844198 2.53274691 -6.49510011 3.1332701 -15.8125 5.1875 C-12.04078025 -0.47007962 -6.3542369 -0.06859333 0 0 Z "
        fill="#FDF0C6"
        transform="translate(285.8125,178.8125)"
      />
      <path
        d="M0 0 C0.33 0 0.66 0 1 0 C1.33 1.98 1.66 3.96 2 6 C1.01 6.33 0.02 6.66 -1 7 C-1 13.93 -1 20.86 -1 28 C-4.8829858 20.2340284 -3.36892645 11.14426538 -1 3 C-0.67 2.01 -0.34 1.02 0 0 Z "
        fill="#F0C439"
        transform="translate(244,208)"
      />
      <path
        d="M0 0 C1.54627671 2.31941506 2.86182828 4.52979752 4.125 7 C4.47820312 7.680625 4.83140625 8.36125 5.1953125 9.0625 C6 11 6 11 6 14 C4.35 12.35 2.7 10.7 1 9 C0.01 9.495 0.01 9.495 -1 10 C-0.67 6.7 -0.34 3.4 0 0 Z "
        fill="#FCF2CA"
        transform="translate(243,240)"
      />
      <path
        d="M0 0 C0.66 0 1.32 0 2 0 C2.66 3.3 3.32 6.6 4 10 C4.66 10 5.32 10 6 10 C6.33 11.98 6.66 13.96 7 16 C2.99065908 12.68192476 1.27544982 8.94719931 0 4 C0 2.68 0 1.36 0 0 Z "
        fill="#F3C02A"
        transform="translate(243,236)"
      />
      <path
        d="M0 0 C1 3 1 3 0.0390625 5.04296875 C-0.42757812 5.75066406 -0.89421875 6.45835937 -1.375 7.1875 C-1.83648437 7.90292969 -2.29796875 8.61835938 -2.7734375 9.35546875 C-3.17820313 9.89816406 -3.58296875 10.44085938 -4 11 C-4.33 11 -4.66 11 -5 11 C-5.09947301 7.5184446 -4.93548664 4.3677519 -4 1 C-2 0 -2 0 0 0 Z "
        fill="#FCF5E1"
        transform="translate(250,195)"
      />
      <path
        d="M0 0 C0.66 0.33 1.32 0.66 2 1 C1.236875 1.7425 0.47375 2.485 -0.3125 3.25 C-4.42221824 7.01876631 -4.42221824 7.01876631 -6 12 C-7.65 12.66 -9.3 13.32 -11 14 C-9.57442379 10.82096506 -7.8226848 8.46341568 -5.5 5.875 C-4.8915625 5.19179687 -4.283125 4.50859375 -3.65625 3.8046875 C-2.46695076 2.50880012 -1.24373566 1.24373566 0 0 Z "
        fill="#F0C437"
        transform="translate(258,190)"
      />
      <path
        d="M0 0 C0.33 0.99 0.66 1.98 1 3 C-0.9375 6.1875 -0.9375 6.1875 -3 9 C-4.32 8.67 -5.64 8.34 -7 8 C-4.69 5.36 -2.38 2.72 0 0 Z "
        fill="#FDEBCA"
        transform="translate(322,252)"
      />
      <path
        d="M0 0 C3.83736322 0.95934081 4.59660228 1.23609263 7 4 C6.01 5.485 6.01 5.485 5 7 C3.35 4.69 1.7 2.38 0 0 Z "
        fill="#FDECC6"
        transform="translate(318,194)"
      />
      <path
        d="M0 0 C2.31 0.33 4.62 0.66 7 1 C7 2.65 7 4.3 7 6 C5.83054208 5.19152271 4.66449539 4.37810888 3.5 3.5625 C2.8503125 3.11003906 2.200625 2.65757812 1.53125 2.19140625 C1.0259375 1.79824219 0.520625 1.40507812 0 1 C0 0.67 0 0.34 0 0 Z "
        fill="#FDEBC6"
        transform="translate(311,188)"
      />
      <path
        d="M0 0 C-0.66 0 -1.32 0 -2 0 C-2.33 0.99 -2.66 1.98 -3 3 C-4.98 3 -6.96 3 -9 3 C-5.83583464 -0.30799106 -4.50236011 -1.35070803 0 0 Z "
        fill="#F0C635"
        transform="translate(272,185)"
      />
    </svg>
  )
}

export default HeightIcon
